import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

import { Alert, AlertDescription } from '../ui';
import type { SalesOrder } from '../../services/types';

interface ShipCompleteWarningsProps {
  salesOrder: SalesOrder;
}

/**
 * Warns when Epicor says the order (OrderHed.ShipOrderComplete) or some of its
 * lines (OrderDtl.ShipLineComplete) must ship in one shipment.
 */
export const ShipCompleteWarnings: React.FC<ShipCompleteWarningsProps> = ({
  salesOrder,
}) => {
  const { t } = useTranslation();
  const shipCompleteLines = salesOrder.lines
    .filter((line) => line.shipLineComplete)
    .map((line) => line.orderLine);

  return (
    <>
      {salesOrder.header.shipOrderComplete && (
        <Alert variant="warning">
          <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
          <AlertDescription className="font-medium">
            {t('salesOrder.shipOrderComplete')}
          </AlertDescription>
        </Alert>
      )}
      {shipCompleteLines.length > 0 && (
        <Alert variant="warning">
          <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
          <AlertDescription className="font-medium">
            {t('salesOrder.shipLinesComplete', {
              lines: shipCompleteLines.join(', '),
            })}
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};
